import { Directive, inject, TemplateRef } from '@angular/core'

interface CarouselItemDirectiveCtx<T> {
  $implicit: T
}

@Directive({ selector: 'ng-template[paiCarouselItem]', standalone: true })
export class CarouselItemDirective<T> {
  readonly templateRef = inject<TemplateRef<CarouselItemDirectiveCtx<T>>>(TemplateRef)

  /**
   * Asserts the correct type of the context for the template that `CarouselItemDirective` will render.
   *
   * The presence of this method is a signal to the Ivy template type-check compiler that the
   * `paiCarouselItem` structural directive renders its template with a specific context type.
   */
  static ngTemplateContextGuard<T>(dir: CarouselItemDirective<T>, ctx: any): ctx is CarouselItemDirectiveCtx<T> {
    return true
  }
}
